import React from 'react';
import Link from 'next/link';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import Button from '@/components/material-ui-kit/components/CustomButtons/Button';
import styles from 'styles/jss/original/components/about/aboutStartSection';

// @ts-expect-error
const useStyles = makeStyles(styles);

const text = {
  title: 'small dish を今すぐ始めましょう',
  description:
    '会員登録なしでも各コンテンツをご覧いただけます。\nまた会員登録は、お使いのSNSアカウントで連携可能です。',
  button: 'ホームへ移動する'
};

const AboutStartSection = () => {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        {/* @ts-expect-error プロパティ「justify」は、タイプ「IntrinsicAttributes & Pick<InferProps<{ children.Requireable<ReactNodeLike>; className」に存在しません。*/}
        <GridContainer justify='center'>
          {/* @ts-expect-error */}
          <GridItem xs={12} sm={10} md={8}>
            <h3 className={classes.title}>{text.title}</h3>
            <h5 className={classes.description}>{text.description}</h5>
          </GridItem>
        </GridContainer>
        {/* @ts-expect-error プロパティ「justify」は、タイプ「IntrinsicAttributes & Pick<InferProps<{ children.Requireable<ReactNodeLike>; className」に存在しません。*/}
        <GridContainer justify='center'>
          {/* @ts-expect-error */}
          <GridItem md={4} sm={4} className={classes.textCenter}>
            <Link href='/'>
              <a>
                {/* @ts-expect-error プロパティ 'children' は、'IntrinsicAttributes & RefAttributes<any>' 型には存在しません。*/}
                <Button color='warning' round className={classes.button}>
                  {text.button}
                </Button>
              </a>
            </Link>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
};

export default AboutStartSection;
